module.exports = __webpack_public_path__ + "img/JakoJako.66c31e12.jpg";